(ns rlws.iot-cloud.frontend.assets
  (:require
   [clojure.string :as str]
   [goog.string :as gstr]
   [goog.string.format]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [reagent.core :as r]
   ["react-console-emulator" :refer [default] :rename {default Terminal}]
   [rlws.iot-cloud.frontend.common :as common]
   [rlws.iot-cloud.frontend.config :as config]
   [rlws.iot-cloud.frontend.assets.components :as assets.components]
   [rlws.iot-cloud.frontend.data :as data]
   [rlws.iot-cloud.frontend.events :as events]
   [rlws.iot-cloud.frontend.forms :as forms]
   [rlws.iot-cloud.frontend.openapi :as openapi]
   [rlws.iot-cloud.frontend.navigation :as navigation]
   [rlws.iot-cloud.frontend.site :as site]
   [rlws.iot-cloud.frontend.subscriptions :as sub]
   [rlws.iot-cloud.frontend.uikit.table :as table]
   [tick.alpha.api :as t]
   [rlws.iot-cloud.frontend.uikit.utils :as utils]
   [rlws.iot-cloud.frontend.components :as components]))

(defn format-lbs
  [lbs]
  (gstr/format "%08d" lbs))

(defn watch-toggle
  [asset iqube scale watched]
  (let [color "red"]
    [:div.flex.flex-row
     {:style {:aspect-ratio "1 / 1" :padding "3px" :margin-right "5px" :cursor "pointer"}}
     [:i.fa.text-xl
      {:style {:display "flex" :align-items "center" :width "25px"}
       :class [(str "text-" color "-500 ") (if watched "fa-eye-slash" "fa-eye")]
       :on-click (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (let [asset-id (:id asset)
                         ip-address (:ip iqube)
                         scale-number (:number scale)]
                     (if watched
                       (rf/dispatch [::events/unwatch-asset asset-id ip-address scale-number])
                       (rf/dispatch [::events/watch-asset asset-id ip-address scale-number]))))}]]))


(defn scale-table
  [scales]
  (let [current-user @(rf/subscribe [::sub/current-user])
        assets @(rf/subscribe [::sub/complete-assets])
        live-assets @(rf/subscribe [::sub/current-scale-status])
        customers @(rf/subscribe [::sub/complete-customers])
        iqubes @(rf/subscribe [::sub/complete-iqubes])
        dealerships @(rf/subscribe [::sub/data :dealerships])]
    {:columns [{:column-key :name
                :column-name "Asset"}
               {:column-key :status
                :column-name "Status"
                :render-fn (fn [row gateway]
                             (let [iqube (first (filter #(= (site/to-plain-id %) (:iqube row)) iqubes))]
                              (if (not (contains? live-assets (str (:gateway row) " " (:number row) " " (:ip iqube))))
                                 [assets.components/asset-status nil]
                                (let [asset (first (filter #(= (first %) (str (:gateway row) " " (:number row) " " (:ip iqube))) live-assets))]
                                  [assets.components/asset-status (second asset)]))))}
               {:column-key :dealership
                :column-name "Dealership"
                :render-fn (fn [row dealership]
                             (let [dealership (first (filter #(= (site/to-plain-id %) (:dealership row)) dealerships))]
                               [:span (:name dealership)]))}
               {:column-key :customer
                :column-name "Customer"
                :render-fn (fn [row gateway]
                             (let [customer (first (filter #(= (site/to-plain-id %) (:customer row)) customers))]
                               [:span (:name customer)]))}
               {:column-key :location
                :column-name "Location"}
               {:column-key :iqube
                :column-name "iQube"
                :render-fn (fn [row gateway]
                             (let [iqube (first (filter #(= (site/to-plain-id %) (:iqube row)) iqubes))]
                               [:span (:name iqube)]))}
               {:column-key :gateway
                :column-name "Gateway"
                :render-fn (fn [row gateway]
                             (let [asset (first (filter #(= (:id %) (:gateway row)) assets))]
                               [:span (:name asset)]))}]
     :filters (cond-> []
                (contains? (set (:roles current-user)) "superuser")
                  (conj {:label "Dealership"
                   :column-key :dealership})
                (not (contains? (set (:roles current-user)) "customer-user"))
                  (conj {:label "Customer"
                   :column-key :customer})
                true (conj {:label "iQube"
                            :column-key :iqube}
                           {:label "Gateway"
                            :column-key :gateway}))
               
               
     :rows scales
     :sort {:name :asc}}))

(defn table
  [assets]
  (let [current-user @(rf/subscribe [::sub/current-user])
        columns (filterv
                 some?
                 [{:column-key :status
                   :column-name "Status"
                   :render-only #{:sort :filter}
                   :render-fn (fn [_ status]
                                [assets.components/asset-status status])}
                  {:column-key :name
                   :column-name "Asset"}
                  {:column-key :dealership
                   :column-name "Dealership"
                   :render-fn (fn [row dealership]
                                [:span (:name dealership)])}
                  {:column-key :customer
                   :column-name "Customer"
                   :render-fn (fn [row customer]
                                [:span (:name customer)])}
                  {:column-key :location
                   :column-name "Location"}
                  (when (contains? (:permissions current-user) :view-home)
                    {:column-key :watched
                     :column-name "Watched"
                     :render-fn watch-toggle})])]
    {:columns columns
     :filters [{:label "Status"
                :column-key :status}
               {:label "Asset"
                :column-key :name}
               {:label "Dealership"
                :column-key :dealership}
               {:label "Customer"
                :column-key :customer}
               {:label "Location"
                :column-key :location}]
     :row-link {:href (fn [asset]
                        (when asset
                          (navigation/id-route
                           :asset
                           {:asset (site/to-plain-id asset)})))}
     :rows assets}))

(defn customer-asset-table
  [assets]
  {:columns [{:column-key :name}]
   :filters [{:label "Gateway"
              :column-key :name}]
   :row-link {:href (fn [asset]
                      (when asset
                        (navigation/id-route
                         :asset
                         {:asset (site/to-plain-id asset)})))}
   :rows assets})

(defn customer-asset-iqube-table
  [assets]
  {:columns [{:column-key :name}]
   :filters [{:label "Gateway"
              :column-key :name}]
   :row-link {:href (fn [asset]
                      (when asset
                        (navigation/id-route
                         :asset
                         {:asset (site/to-plain-id asset)})))}
   :rows assets
   :sort {:name :asc}})

(defn all-assets
  []
  (let [page-title @(rf/subscribe [::sub/page-title])
        assets @(rf/subscribe [::sub/complete-assets])
        scales @(rf/subscribe [::sub/complete-scales])
        current-user @(rf/subscribe [::sub/current-user])]
    [:<>
     [:div {:style {:display "flex"
                    :flex-direction "row"
                    :justify-content "space-between"
                    :align-items "flex-end"
                    :align-content "flex-end"}}
      [:h1.text-lg.margin-bottom-sm page-title]]
     (if (= scales nil)
       [:div.center [components/loader]]
       [table/scale-table
        (scale-table scales)])]))

(defn send-edp-cmd
  [{:keys [terminal asset-id command ip port]}]
  (rf/dispatch [::events/send-device-command
                terminal
                :commands
                {:asset-id asset-id
                 :rlc-secret config/state-secret
                 :command
                 {:device-driver (if (= "1.2.3.4" ip)
                                   :iqube2-sim
                                   :iqube2)
                  :device-command :edp-command
                  :device-args {:ip-address ip
                                :port port
                                :timeout-ms 1000
                                :edp-command command}}}]))

(defn console-component
  [gateway iqube scale]
  (let [terminal (atom nil)]
    (fn []
      (let [live? (get @(rf/subscribe [::sub/live-assets]) (str (:id gateway) " " (:number scale) " " (:ip iqube)))
            ip (:ip iqube)
            port 10001]
        [:div.command-component
         [:h2.command-component__heading {:style {:margin-bottom "0.6rem"}}
          "Console"]
         [:div {:key live?}
          (if live?
            [:> Terminal
             {:style {:max-height "300px"}
              :commands
              {:unknown
               {:fn (fn [& args]
                      (send-edp-cmd {:terminal terminal
                                     :asset-id (:id gateway)
                                     :command (apply str args)
                                     :ip ip
                                     :port port}))}}
              :welcome-message (str "Connected to " ip ":" port " (SC" (:number scale) ")")
              :prompt-label (str "[SC" (:number scale) "]$")
              :no-defaults true
              :ref (fn [element]
                     (reset! terminal element))}]
            [:> Terminal
             {:style {:max-height "300px"}
              :welcome-message "Offline"
              :commands {}
              :disabled true
              :read-only true
              :no-defaults true}])]]))))

(defn camera-click-handler [asset camera]
  (fn []
    (let [send-snapshot-command
          #(rf/dispatch [::events/send-camera-command
                         (site/to-plain-id asset)
                         camera])]
  
      (send-snapshot-command)
      (rf/dispatch
       [:modal
        {:show? true
         :title (if-let [name (:name camera)]
                  (str "View - " name)
                  "View - IP Camera")
         :child
         (fn []
           (let [{:keys [state] :as camera-command}
                 @(rf/subscribe [::sub/camera-command
                                 (site/to-plain-id asset)])]
             [:div.asset__camera-view
              [:div.flex.flex-center
               {:style {:min-height "20rem"
                        :max-width "100%"}}
               (case state
                 :pending [components/loader]
                 :complete
                 (try
                   (let [image-data (get-in camera-command
                                            [:success :snapshot])
                         mime-type (common/base64-to-image-mime image-data)
                         data-uri-prefix (str "data:" mime-type ";base64,")]
                     [:img {:style {:min-height "20rem"}
                            :src (str data-uri-prefix image-data)}])
                   (catch :default e
                     [:p "An error occurred"]))
                 [:p "Something went wrong"])]
              [:div.margin-top-md
               [:button.btn {:type "button"
                             :on-click send-snapshot-command}
                "Refresh"]]]))}]))))


(defn camera-button
  [asset status camera] 
  (if status
    [:a {:key "camera"
         :on-click (camera-click-handler asset camera)
         :style {:display "flex"}}
     [:i.fa.fa-camera {:style {:font-size "16px"}}]]
    [:a {:key "camera"
         :title "Camera Unavailable: Gateway not connected"
         :style {:display "flex" :pointer "disabled"}}
     [:i.fa.fa-camera.text-gray-500 {:style {:font-size "16px"}}]]))

(defn accessories-component
  [gateway status scale asset] 
  (let [gateway-status @(rf/subscribe [::sub/gateway-status])]
   [:div {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"}}
    (if (empty? (:components gateway))
      [:span.no-accessories "No Accessories Added"]
      (for [accessory (:components gateway) :when (= (:scale accessory) (:number scale))]
        ^{:key accessory}
        [:div.accessory-box
         (if (= (:component-type accessory) "camera")
           [:div.accessory-icon
            (when-let [camera accessory]
              [camera-button asset gateway-status camera])]
           (if (= (:component-type accessory) "indicator")
             [:div.accessory-icon
              [:i.fa.fa-tablet]]
             (if (= (:component-type accessory) "remote-display")
               [:div.accessory-icon
                [:i.fa.fa-wifi]])))
         [:div.accessory-name
          {:on-click (when (= "camera" (:component-type accessory)) (camera-click-handler asset accessory))}
          [:span (:name accessory)]]
         [:div.accessory-type
          (case (:component-type accessory)
            "camera" [:span "IP Camera"]
            "indicator" [:span "Indicator"]
            "remote-display" [:span "Remote Display"]
            [:span (:component-type accessory)])]]))]))

(defn scale-cells-subheader
  [{:keys [status scale iqube asset]}] 
  (let [load-cells (:load-cells status)
        load-cells (if (= 3 (count load-cells))
                     (conj (vec load-cells) {:blank true})
                     load-cells)
        gateway-status @(rf/subscribe [::sub/gateway-status])
        current-user @(rf/subscribe [::sub/current-user])
        permissions (set (:permissions current-user))
        asset-id (:asset @(rf/subscribe [::sub/path-params]))]
    (if (and (= (:number scale) (:number status)) (= (:gateway scale) (:asset-id (:status status))) (= (:ip iqube) (:ip-address status)))
      [:div.scale-cells-subheader__container
       (if load-cells
         [:div {:style {:flex-direction :row
                        :width "100%"
                        :margin-top "20px"
                        :color "var(--grayscale-gray-100, #202532)"
                        :font-feature-settings "'clig' off, 'liga' off"
                        :font-size "14px"
                        :font-style "normal"
                        :font-weight "600"
                        :line-height "20px"}}
          "Load Cell Layout"
          [:div
           [:div.scale-cell__container
            (for [load-cell (keep-indexed #(when (even? %1) %2) load-cells)]
              ^{:key load-cell}
              [assets.components/scale-cell-box load-cell])]
           [:div.scale-cell__container
            (for [load-cell (keep-indexed #(when (odd? %1) %2) load-cells)]
              ^{:key load-cell}
              [assets.components/scale-cell-box load-cell])]]])
       (if status
         [:div {:style {:margin-top "20px"}}
          [:div {:style {:display "flex" :flex-direction "row"}}
           [:div {:style {:width "42%"}} "Live Weight"]
           [:div {:style {:display "inline-block"}} "Last Updated:" (:last-updated status)]]

          [assets.components/live-weight-subheader
           {:status status
            :asset asset
            :editable? (permissions :modify-assets)
            :additional-controls
            (when-let [camera (potpuri/find-first (:components asset)
                                                  {:component-type "camera"})]
              [[camera-button asset gateway-status camera]])}]]
         [:div.connecting-div [assets.components/online-offline-component (str asset-id " " (:number scale) " " (:ip iqube))]])]
      [:div.connecting-div [assets.components/online-offline-component (str asset-id " " (:number scale) " " (:ip iqube))]])))

(defn iqube-cells-subheader
  [{:keys [iqube]}]
  (let [load-cells @(rf/subscribe [::sub/live-cells])
        load-cells (sort-by first load-cells)
        live @(rf/subscribe [::sub/live])]
      [:div.scale-cells-subheader__container
       (if (and load-cells (= live "Live"))
         [:div {:style {:flex-direction :row
                        :width "100%"
                        :margin-top "20px"}}
          [:div
           (for [board-group (partition-by #(and (< 0 (mod (first %) 8)) (> 5 (mod (first %) 8))) load-cells)]
             ^{:key (first (first board-group))}
              (let [board-number (Math/ceil (/ (:number (second (first board-group))) 4))]
                [:div
                 (if (= board-number 1)
                   [:span.board-type "Primary"]
                   [:span.board-type "Secondary"])
                 [:span.serial-number (str "Board " board-number " - SN " (or (:board-serial-number (second (first board-group))) "XXXXXXXX"))]
                 [:div.scale-cell__container
                  (for [load-cell board-group]
                    ^{:key (second load-cell)}
                    [assets.components/scale-cell-box (second load-cell)])]]))]]
         [:div.connecting-div [assets.components/online-offline-component (str (:gateway iqube) " 1 " (:ip iqube))]])]))

(defn alerts-table
  [asset-id permissions]
  (let [alerts @(rf/subscribe [::sub/complete-alerts asset-id])
        scale @(rf/subscribe [::sub/data :scale])
        iqube @(rf/subscribe [::sub/data :iqube])]
    [:div.alerts-table
     [:h2.alerts-table__heading "Alert History"]
     [table/table
      {:columns [{:column-key :capability
                  :column-name "Alert type"
                  :render-only #{:sort :filter}
                  :render-fn
                  (fn [_ v]
                    (let [icon-class (common/alert-icon-class (keyword v))
                          text (some->> (str/split (str/replace v #"dia-" "") #"-")
                                        (map str/capitalize)
                                        (str/join " "))]
                      [:div.flex.items-center
                       [:div.padding-right-sm
                        {:class icon-class}]
                       [:span text]]))}
                 {:column-key :cell
                  :column-name "Cell Name"
                  :render-only #{:sort :filter}
                  :render-fn (fn [_ v]
                               (if v
                                 (str "CELL #" v)
                                 "N/A"))}
                 {:column-key :cell-board
                  :column-name "Cell Board"
                  :render-fn (fn [_ v]
                               (if v v "N/A"))}
                 {:column-key :timestamp
                  :column-name "Date"
                  :render-only #{:sort :filter}
                  :render-fn (fn [_ v] (when v (sub/format-date v)))}]
       :filters [{:label "Error"
                  :column-key :capability}
                 {:label "Cell Name"
                  :column-key :cell}]
       :row-link (when (permissions :modify-service-notes)
                   {:on-click
                    (fn [{:keys [capability cell]}]
                      (let [{:keys [title description]}
                            (data/diagnostics (keyword capability))]
                        (rf/dispatch
                         [:modal
                          {:show? true
                           :title (str "Add Service Note")
                           :child [forms/create-service-note
                                   {"title"     title
                                    "note-type" "ongoing-issue"
                                    "body"      description
                                    "cell"      (or cell 0)
                                    "ip-address" (:ip iqube)
                                    "scale-number" (str (:number scale))}]}])))})
       
       :rows (filter #(and (= (:scale-number %) (str (:number scale))) (= (:ip-address %) (:ip iqube))) alerts)}]]))

(defn asset-docs [{:keys [id]}]
  (let [documents (->> @(rf/subscribe [::sub/data :documents])
                       (filter #(= id (:asset %)))
                       distinct)]
    [:<>
     [:h2.documents-table__heading "Documents"]
     [table/table
      {:columns [{:column-key :title
                  :column-name "Title"
                  :render-fn (fn [_ v]
                               [:div {:style {:display "flex"}}
                                [:i.far.fa-file-pdf]
                                [:p {:style {:margin-left "0.4em"}} v]])
                  :render-only #{:sort :filter}}
                 {:column-key :manufacturer
                  :column-name "Manufacturer"}
                 {:column-key :part-number
                  :column-name "Part Number"}]
       :filters []
       :buttons [[:button.dropdown-filter__button
                  {:class "service-notes__add-button"
                   :on-click #(rf/dispatch [:modal {:show? true
                                                    :title (str "Add Document Link")
                                                    :child [forms/create-document-link]}])}
                  [:div.dropdown-filter__selected "Add Document"]
                  [:i.fas.fa-plus.color-success]]]
       :row-link {:href (fn [{:keys [url]}]
                          url)
                  :target "_blank"}
       :rows documents}]]))

(defn asset-notes [permissions]
  (let [service-notes @(rf/subscribe [::sub/service-notes])
        iqube @(rf/subscribe [::sub/data :iqube])
        scale @(rf/subscribe [::sub/data :scale])
        users @(rf/subscribe [::sub/users])]
    [:div.uikit-table
     [:h2.documents-table__heading "Service Notes"]
     [:div.service-notes__sub-heading.table__dropdown-filters-container
      ;; [:div.table__dropdown-filter-container
      ;;  {:style {:margin-right "1em"}}
      ;;  [:div.table__dropdown-filter-container
      ;;   [:div.dropdown-filter__label
      ;;    [:p "Search all"]]
      ;;   [:div.filter__search-all
      ;;    [:div.form-control-wrapper
      ;;     [:input.form-control
      ;;      {:type "text"}]]]]]
      ;; [:div.table__dropdown-filter-container
      ;;  [:div.dropdown-filter__label
      ;;   "Error"]
      ;;  [:button.dropdown-filter__button
      ;;   [:div.dropdown-filter__selected "All"]
      ;;   [:i.fas.fa-caret-down]]]
      (when (permissions :modify-service-notes)
        [:div.table__dropdown-filter-container
         [:div.dropdown-filter__label
          [:p.opacity-0 "add"]]
         [:button.dropdown-filter__button
          {:class "service-notes__add-button"
           :on-click #(rf/dispatch [:modal {:show? true
                                            :title (str "Add Service Note")
                                            :child [forms/create-service-note {"ip-address" (:ip iqube)
                                                                               "scale-number" (str (:number scale))}]}])}
          [:div.dropdown-filter__selected "+ Add Note"]]])]
     [:div.asset-service-notes
      (for [{:keys [created-by timestamp title cell body editable?] :as data}
            service-notes]
        ^{:key (str data)}
        [:div.asset-service-notes__group
         [:div.asset-service-notes__header-group
          [:div.asset-service-notes__item.note-info
           [:p.note-info__heading "Date"]
           [:p (t/format "EEEE, MMM dd, yyyy" (t/date timestamp))]]
          #_(when false ;;editable?
              [:div.head__icon
               {:on-click
                #(rf/dispatch [:modal {:show? true
                                       :title (str "Edit Service Note")
                                       :child [forms/form-component
                                               (forms/edit-asset-note data)]}])}
               [:i.fas.fa-edit] "Edit"])
          [:div.asset-service-notes__item.note-info
           [:p.note-info__heading "Created By"]
           [:p (:name created-by)]]
          [:div.asset-service-notes__item.note-info
           [:p.note-info__heading "Cell"]
           [:p (if (< 0 cell) cell "-")]]]
         [:div.asset-service-notes__subgroup
          [:div.asset-service-notes__item.note-info
           [:p.note-info__heading "Title"]
           [:p title]]]
         [:div.asset-service-notes__subgroup
          [:div.asset-service-notes__item.note-info
           [:p.note-info__heading "Note"]
           [:p body]]]])
      [:div.asset-service-notes__bottom-border]]]))

(defn send-snapshot-command
  [{:keys [terminal asset-id command ip port]}]
  (rf/dispatch [::events/send-device-command
                terminal
                :commands
                {:asset-id asset-id
                 :rlc-secret config/state-secret
                 :command
                 {:device-driver (if (= "1.2.3.4" ip)
                                   :iqube2-sim
                                   :iqube2)
                  :device-command :edp-command
                  :device-args {:ip-address ip
                                :port port
                                :timeout-ms 1000
                                :edp-command command}}}]))

(defn scrollable-content
  [{:keys [scroll-selector]} & children]
  (let [{:scroll-navigation/keys [start stop]}
        (common/scroll-navigation scroll-selector)]
    (r/create-class
     {:component-did-mount
      (fn []
        (start))
      :component-will-unmount
      (fn []
        (stop))
      :reagent-render
      (fn [props & children]
        (into [:div.scrollable-content]
              children))})))

(defn one-asset-header [customer site gateway iqube scale]
  (let [assets @(rf/subscribe [::sub/complete-assets])
        current-scale-status @(rf/subscribe [::sub/current-scale-status])
        current-user @(rf/subscribe [::sub/current-user])
        dialog@(rf/subscribe [::sub/dialog])
        gateway-status @(rf/subscribe [::sub/gateway-status])
        watched-assets (:watched-assets @(rf/subscribe [::sub/data :current-user]))] 
   [:div.iqube-detail 
    (when (some #(= % "superuser") (:roles current-user))
      [:div {:style {:float "right"}}
       [:button.add-camera-button {:on-click  (fn []
                                                (if (= dialog :closed)
                                                  (rf/dispatch [::events/set-dialog :add-accessory])
                                                  (rf/dispatch [::events/set-dialog :closed])))}
        [:span "+ Add Accessory"]
        [:div.vertical-divider]
        [:img {:src "/img/icon-chevron-down-white.svg"}]]
       (when (= dialog :add-accessory)
         [:div.accessory-dropdown
          [:div {:style {:margin-bottom "8px"}
                 :on-click (fn [] (rf/dispatch [::events/set-dialog :add-camera]))} "IP Camera"]
          [:div {:style {:margin-bottom "8px"}
                 :on-click (fn [] (rf/dispatch [::events/set-dialog :add-indicator]))} "Indicator"]
          [:div {:on-click (fn [] (rf/dispatch [::events/set-dialog :add-remote-display]))} "Remote Display"]])]) 
    [:div.iqube-header
     [:div.flex.flex-center
      [:img {:src "/img/icon-gateway.svg"}]
      [:span.gateway (:name gateway)]]
     [:img {:src "/img/icon-arrow-right.svg"}]
     [:a.flex.flex-center {:href (navigation/id-route
                                  :iqube-detail
                                  {:iqube-detail (site/to-plain-id iqube)})
                           :style {:display "flex" :align-items "center"}
                           :on-click (fn [] (rf/dispatch [:fetch/data [:asset] (site/resource-path :assets (site/to-plain-id gateway))]))}
      [:img {:src "/img/icon-accessories.svg"}]
      [:span.gateway.underline (:name iqube)]]
     [:img {:src "/img/icon-arrow-right.svg"}]
     [:div {:style {:display "flex"
                    :flex-direction "row"
                    :align-items "center"}}
      [utils/scale-icon (:category scale)]
      [:span.iqube {:style {:margin-left "5px"}} (:name scale)]]
     (when (contains? (:permissions current-user) :modify-assets)
       [:div.edit-iqube-button {:on-click (fn []
                                            (rf/dispatch [:fetch/data [:scale] (site/resource-path :scales (site/to-plain-id scale))])
                                            (rf/dispatch [::events/set-dialog :edit-scale]))}
        [:img {:src "/img/icon-edit.svg"}] "Edit"])]
    [:div.iqube-details
     (if (not (contains? current-scale-status (str (:gateway scale) " " (:number scale) " " (:ip iqube))))
       [assets.components/asset-status nil]
       (for [scale-status current-scale-status :when (= (first scale-status) (str (:gateway scale) " " (:number scale) " " (:ip iqube)))]
         ^{:key scale}
         [assets.components/asset-status (second scale-status)]))
     [:span "Customer: "
      (if (some #(= % "superuser") (:roles current-user))
        [:a {:href (navigation/id-route
                    :customer
                    {:customer (site/to-plain-id customer)})}
         [:span.underline (:name customer)]]
        [:span (:name customer)])]
     [:span "Site: "
      (if (some #(= % "superuser") (:roles current-user))
        [:a {:href (navigation/id-route
                    :site
                    {:site (site/to-plain-id site)})}
         [:span.underline (:name site)]]
        [:span (:name site)])]
     [:span "Location: " (:location scale)]
     (when (contains? (:permissions current-user) :view-home)
       [watch-toggle gateway iqube scale (some #(= % (str (:gateway scale) " " (:number scale) " " (:ip iqube)))
                                             watched-assets)])
     (when-let [camera (potpuri/find-first (:components gateway)
                                           #(and (= (:component-type %) "camera") (= (:scale %) (:number scale))))]
       [:div
        [camera-button gateway gateway-status camera]])]]))

(defn one-asset-tab-header [tab current-user] 
  [:div {:style
         {:display "flex",
          :flex-direction "row"
          :padding "20px 0px 0px 20px"
          :overflow-x "auto"
          :background "var(--netural-100, #EFEFEF)"}}
   [:button 
    {:class (if (= tab :history) "header-button-selected" "header-button")
     :type "button"
     :on-click (fn []
                 (rf/dispatch [::events/set-asset-tab :history]))}
    [:img {:src "/img/icon-alert-history.svg"}]
    [:span "Alert History"]]
   (when (contains? (:permissions current-user) :view-service-notes)
    [:button
     {:class (if (= tab :notes) "header-button-selected" "header-button")
      :type "button"
      :on-click (fn []
                  (rf/dispatch [::events/set-asset-tab :notes]))}
     [:img {:src "/img/icon-service-notes.svg"}]
     [:span "Service Notes"]])
   (when (contains? (:permissions current-user) :modify-assets)
     [:button
      {:class (if (= tab :console) "header-button-selected" "header-button")
       :type "button"
       :on-click (fn []
                   (rf/dispatch [::events/set-asset-tab :console]))}
      [:img {:src "/img/icon-console.svg"}]
      [:span "Console"]])
   [:button
    {:class (if (= tab :accessories) "header-button-selected" "header-button")
     :type "button"
     :on-click (fn []
                 (rf/dispatch [::events/set-asset-tab :accessories]))}
    [:img {:src "/img/icon-asset.svg"}]
    [:span "Accessories"]]])

(def submitting? (r/atom false))

(defn one-asset
  []
  (let [{:keys [path-params query-params]} @(rf/subscribe [::sub/current-route])
        page @(rf/subscribe [::sub/page])
        tabs @(rf/subscribe [::sub/asset-tab])
        status @(rf/subscribe [::sub/asset-status])
        current-status @(rf/subscribe [::sub/current-status])
        asset @(rf/subscribe [::sub/current-asset])
        customer @(rf/subscribe [::sub/data :customer])
        site @(rf/subscribe [::sub/data :site])
        gateway @(rf/subscribe [::sub/data :asset])
        iqube @(rf/subscribe [::sub/data :iqube])
        scale @(rf/subscribe [::sub/data :scale])
        current-user @(rf/subscribe [::sub/current-user])
        permissions (set (:permissions current-user))
        edit-dialog @(rf/subscribe [::sub/dialog])]
    (if (and (= (site/to-plain-id asset) (:asset path-params)) (= (site/to-plain-id iqube) (:iqube query-params)) (= (site/to-plain-id scale) (:scale query-params)))
      (do (when-not customer
            (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers (:customer scale))]))
          (when-not site
            (rf/dispatch [:rlws.iot-cloud.frontend.events/start-watch-alerts (:gateway scale) (:number scale) (:ip iqube)])
            (rf/dispatch [:fetch/data [:alerts (:gateway scale)] (site/resource-path :alerts) {:asset (:gateway scale) :scale-number (:number scale) :ip-address (:ip iqube)}])
            (rf/dispatch [:fetch/data [:service-notes] (site/resource-path :service-notes) {:asset (:gateway scale) :scale-number (:number scale) :ip-address (:ip iqube)}])
            (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (:site scale))]))
          [:div
           (when (= (site/to-plain-id asset) (:gateway scale))
                [one-asset-header customer site gateway iqube scale])
           (when (and (= (:number status) (:number scale)) (= (:ip iqube) (:ip-address status)))
             (rf/dispatch [::events/set-current-status status]))
           [components/subheader {:fixed? false
                                  :box-shadow? true}
            [:div
             [scale-cells-subheader
              {:status current-status
               :scale scale
               :iqube iqube
               :asset asset}]]]

           [one-asset-tab-header tabs current-user]

           (when (= edit-dialog :close)
             (reset! submitting? false))

           (when (= edit-dialog :add-camera)
             [:div
              [:div.outside-modal
               {:on-click (fn []
                            (rf/dispatch [::events/set-dialog :close]))}]
              [:div
               {:style {:position        "fixed"
                        :top             "50%"
                        :left            "50%"
                        :border          "1px solid black"
                        :borderRadius    "5px"
                        :transform       "translate(-50%, -50%)"
                        :backgroundColor "white"
                        :zIndex          "100"
                        :padding         "20px"}}
               (let [state (r/atom nil)
                     openapi      (rf/subscribe [::sub/data :openapi])
                     current-user (rf/subscribe [::sub/current-user])
                     dealerships  (rf/subscribe [::sub/data :dealerships])
                     form-state   state]
                 [:div {}
                  [:h1 {:class "customer__sub-heading"} "Add Camera"]
                  (let [superuser? (contains? (:roles @current-user) "superuser")]
                    [:<>
                     [:div {:style {:display         "flex"
                                    :flex-direction  "row"
                                    :justify-content "space-between"}}
                      [:div
                       {:style {:flex-grow 1}}
                       (if openapi
                         [openapi/form
                          {:openapi          @openapi
                           :schema-name      "Camera"
                           :form-data        @form-state
                           :remap-properties {"dealership" (when superuser?
                                                             #(openapi/create-enum % @dealerships))}
                           :on-submit        (fn [data]
                                               (if (nil? (:components gateway))
                                                 (assoc gateway :components (vector)))
                                               (rf/dispatch
                                                [::events/put-data
                                                 (str "/api/assets/" (:id gateway))
                                                 (cond-> gateway
                                                   true (update-in [:components] conj (assoc data :scale (:number scale)))
                                                   true (assoc :crux.db/id (:id gateway)))
                                                 [::events/modify-components-success "Added Accessory" :assets gateway]])
                                               (reset! submitting? true))}
                          [:div.dropdown-input
                           [:label "Gateway"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name gateway)}]]
                          [:div.dropdown-input
                           [:label "iQUBE"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name iqube)}]]
                          [:div.dropdown-input
                           [:label "Scale"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name scale)}]]
                          [:div {:style {:display         "flex"
                                         :justify-content "center"
                                         :paddingLeft     "20px"
                                         :paddingRight    "20px"
                                         :margin-top      "15px"
                                         :align-items     "center"
                                         :align-content   "center"}}
                           [:button
                            {:class "customer__cancel-button"
                             :type "button"
                             :on-click (fn []
                                         (rf/dispatch [::events/set-dialog :close]))}
                            [:span "Cancel"]]
                           [:button
                            {:class "customer__save-button"
                             :type :submit
                             :disabled @submitting?}
                            (if @submitting?
                              [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                              [:span "Save"])]]]
                         [:p "Loading..."])]]])])
               [:div {:style {:display         "flex"
                              :justify-content "center"
                              :paddingLeft     "40px"
                              :paddingRight    "40px"
                              :align-items     "center"
                              :align-content   "center"
                              :margin-top       "20px"}}]]])

           (when (= edit-dialog :add-indicator)
             [:div
              [:div.outside-modal
               {:on-click (fn []
                            (rf/dispatch [::events/set-dialog :close]))}]
              [:div
               {:style {:position        "fixed"
                        :top             "50%"
                        :left            "50%"
                        :border          "1px solid black"
                        :borderRadius    "5px"
                        :transform       "translate(-50%, -50%)"
                        :backgroundColor "white"
                        :zIndex          "100"
                        :padding         "20px"}}
               (let [state (r/atom nil)
                     openapi      (rf/subscribe [::sub/data :openapi])
                     current-user (rf/subscribe [::sub/current-user])
                     dealerships  (rf/subscribe [::sub/data :dealerships])
                     form-state   state]
                 [:div {}
                  [:h1 {:class "customer__sub-heading"} "Add Indicator"]
                  (let [superuser? (contains? (:roles @current-user) "superuser")]
                    [:<>
                     [:div {:style {:display         "flex"
                                    :flex-direction  "row"
                                    :justify-content "space-between"}}
                      [:div
                       {:style {:flex-grow 1}}
                       (if openapi
                         [openapi/form
                          {:openapi          @openapi
                           :schema-name      "Indicator"
                           :form-data        @form-state
                           :remap-properties {"dealership" (when superuser?
                                                             #(openapi/create-enum % @dealerships))}
                           :on-submit        (fn [data]
                                               (if (nil? (:components gateway))
                                                 (assoc gateway :components (vector)))
                                               (rf/dispatch
                                                [::events/put-data
                                                 (str "/api/assets/" (:id gateway))
                                                 (cond-> gateway
                                                   true (update-in [:components] conj (assoc data :scale (:number scale)))
                                                   true (assoc :crux.db/id (:id gateway)))
                                                 [::events/modify-components-success "Added Accessory" :assets gateway]])
                                               (reset! submitting? true))}
                          [:div.dropdown-input
                           [:label "Gateway"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name gateway)}]]
                          [:div.dropdown-input
                           [:label "iQUBE"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name iqube)}]]
                          [:div.dropdown-input
                           [:label "Scale"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name scale)}]]
                          [:div {:style {:display         "flex"
                                         :justify-content "center"
                                         :paddingLeft     "20px"
                                         :paddingRight    "20px"
                                         :margin-top      "15px"
                                         :align-items     "center"
                                         :align-content   "center"}}
                           [:button
                            {:class "customer__cancel-button"
                             :type "button"
                             :on-click (fn []
                                         (rf/dispatch [::events/set-dialog :close]))}
                            [:span "Cancel"]]
                           [:button
                            {:class "customer__save-button"
                             :type :submit
                             :disabled @submitting?}
                            (if @submitting?
                              [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                              [:span "Save"])]]]
                         [:p "Loading..."])]]])])
               [:div {:style {:display         "flex"
                              :justify-content "center"
                              :paddingLeft     "40px"
                              :paddingRight    "40px"
                              :align-items     "center"
                              :align-content   "center"
                              :margin-top       "20px"}}]]])

           (when (= edit-dialog :add-remote-display)
             [:div
              [:div.outside-modal
               {:on-click (fn []
                            (rf/dispatch [::events/set-dialog :close]))}]
              [:div
               {:style {:position        "fixed"
                        :top             "50%"
                        :left            "50%"
                        :border          "1px solid black"
                        :borderRadius    "5px"
                        :transform       "translate(-50%, -50%)"
                        :backgroundColor "white"
                        :zIndex          "100"
                        :padding         "20px"}}
               (let [state (r/atom nil)
                     openapi      (rf/subscribe [::sub/data :openapi])
                     current-user (rf/subscribe [::sub/current-user])
                     dealerships  (rf/subscribe [::sub/data :dealerships])
                     form-state   state]
                 [:div {}
                  [:h1 {:class "customer__sub-heading"} "Add Remote Display"]
                  (let [superuser? (contains? (:roles @current-user) "superuser")]
                    [:<>
                     [:div {:style {:display         "flex"
                                    :flex-direction  "row"
                                    :justify-content "space-between"}}
                      [:div
                       {:style {:flex-grow 1}}
                       (if openapi
                         [openapi/form
                          {:openapi          @openapi
                           :schema-name      "RemoteDisplay"
                           :form-data        @form-state
                           :remap-properties {"dealership" (when superuser?
                                                             #(openapi/create-enum % @dealerships))}
                           :on-submit        (fn [data]
                                               (if (nil? (:components gateway))
                                                 (assoc gateway :components (vector)))
                                               (rf/dispatch
                                                [::events/put-data
                                                 (str "/api/assets/" (:id gateway))
                                                 (cond-> gateway
                                                   true (update-in [:components] conj (assoc data :scale (:number scale)))
                                                   true (assoc :crux.db/id (:id gateway)))
                                                 [::events/modify-components-success "Added Accessory" :assets gateway]])
                                               (reset! submitting? true))}
                          [:div.dropdown-input
                           [:label "Gateway"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name gateway)}]]
                          [:div.dropdown-input
                           [:label "iQUBE"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name iqube)}]]
                          [:div.dropdown-input
                           [:label "Scale"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name scale)}]]
                          [:div {:style {:display         "flex"
                                         :justify-content "center"
                                         :paddingLeft     "20px"
                                         :paddingRight    "20px"
                                         :margin-top      "15px"
                                         :align-items     "center"
                                         :align-content   "center"}}
                           [:button
                            {:class "customer__cancel-button"
                             :type "button"
                             :on-click (fn []
                                         (rf/dispatch [::events/set-dialog :close]))}
                            [:span "Cancel"]]
                           [:button
                            {:class "customer__save-button"
                             :type :submit
                             :disabled @submitting?}
                            (if @submitting?
                              [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                              [:span "Save"])]]]
                         [:p "Loading..."])]]])])
               [:div {:style {:display         "flex"
                              :justify-content "center"
                              :paddingLeft     "40px"
                              :paddingRight    "40px"
                              :align-items     "center"
                              :align-content   "center"
                              :margin-top       "20px"}}]]])

           (when (= edit-dialog :edit-scale)
             [:div
              [:div.outside-modal
               {:on-click (fn []
                            (rf/dispatch [::events/set-dialog :close]))}]
              [:div
               {:style {:position        "fixed"
                        :top             "50%"
                        :left            "50%"
                        :border          "1px solid black"
                        :borderRadius    "5px"
                        :transform       "translate(-50%, -50%)"
                        :backgroundColor "white"
                        :zIndex          "100"
                        :padding         "20px"}}
               (let [state (r/atom nil)
                     openapi      (rf/subscribe [::sub/data :openapi])
                     current-user (rf/subscribe [::sub/current-user])
                     dealerships  (rf/subscribe [::sub/data :dealerships])
                     form-state   state]
                 [:div {}
                  [:h1 {:class "customer__sub-heading"} "Edit Scale"]
                  (let [superuser? (some #(= % "superuser") (:roles @current-user))
                        categories ["Truck Scale" "Floor Scale" "Bench Scale" "Tank Scale" "Other"]]
                    [:<>
                     [:div {:style {:display         "flex"
                                    :flex-direction  "row"
                                    :justify-content "space-between"}}
                      [:div
                       {:style {:flex-grow 1}}
                       (if openapi
                         [openapi/form
                          {:openapi          @openapi
                           :schema-name      "Scale"
                           :form-data        @form-state
                           :remap-properties {"dealership" (when superuser?
                                                             #(openapi/create-enum % @dealerships))
                                              "name" (constantly {"title" "Name"
                                                                  "type" "string"
                                                                  "default" (:name scale)})
                                              "location" (constantly {"title" "Location"
                                                                      "type" "string"
                                                                      "default" (:location scale)})
                                              "number" (constantly {"title" "Scale Number"
                                                                    "type" "integer"
                                                                    "default" (:number scale)
                                                                    "minimum" 1})
                                              "load-cell" (if (:load-cell scale) 
                                                            (constantly {"title" "Load Cell Quantity"
                                                                         "type" "integer"
                                                                         "default" (:load-cell scale)})
                                                            (constantly {"title" "Load Cell Quantity"
                                                                         "type" "integer"
                                                                         "minimum" 1}))}
                           :on-submit        (fn [data]
                                               (rf/dispatch
                                                [::events/put-data
                                                 (str "/api/scales/" (site/to-plain-id scale))
                                                 (cond-> data
                                                   true (assoc :customer (site/to-plain-id customer))
                                                   true (assoc :site (site/to-plain-id site))
                                                   true (assoc :gateway (:id @(rf/subscribe [::sub/data :asset])))
                                                   true (assoc :iqube (site/to-plain-id @(rf/subscribe [::sub/data :iqube])))
                                                   true (assoc :category @(rf/subscribe [::sub/selected-scale-type]))
                                                   (nil? (:load-cell data)) (dissoc :load-cell)
                                                   (not superuser?) (assoc :dealership (:dealership customer))
                                                   superuser? (assoc :dealership @(rf/subscribe [::sub/selected-scale-dealership])))
                                                 [::events/modify-object-success "Scale Edited" :scales]])
                                               (reset! submitting? true)
                                               (rf/dispatch [:fetch/data [:scale] (site/resource-path :scales (site/to-plain-id scale))]))}
                          (when superuser?
                            [:div.dropdown-input
                             [:label "Dealership"]
                             [:select.form-control {:field :list :id :many.options
                                                    :default-value (:dealership scale)
                                                    :on-change (fn [evt]
                                                                 (rf/dispatch [::events/set-selected-scale-dealership (-> evt .-target .-value)]))}
                              (rf/dispatch [::events/set-selected-scale-dealership (:dealership scale)])
                              (for [dealership @dealerships]
                                ^{:key (site/to-plain-id dealership)}
                                [:option {:value (site/to-plain-id dealership)} (:name dealership)])]])
                          [:div.dropdown-input
                           [:label "Scale Type"]
                           [:select.form-control {:field :list :id :many.options
                                                  :default-value (:category scale)
                                                  :on-change (fn [evt]
                                                               (rf/dispatch [::events/set-selected-scale-type (-> evt .-target .-value)]))}
                            (rf/dispatch [::events/set-selected-scale-type (:category scale)])
                            (for [category categories]
                              ^{:key category}
                              [:option {:value category} category])]]
                          [:div.dropdown-input
                           [:label "Gateway"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name gateway)}]]
                          [:div.dropdown-input
                           [:label "iQUBE"]
                           [:input.form-control {:type "text"
                                                 :disabled true
                                                 :value (:name iqube)}]]
                          [:div {:style {:display         "flex"
                                         :justify-content "center"
                                         :paddingLeft     "20px"
                                         :paddingRight    "20px"
                                         :margin-top      "15px"
                                         :align-items     "center"
                                         :align-content   "center"}}
                           [:button
                            {:class "customer__cancel-button"
                             :type "button"
                             :on-click (fn []
                                         (rf/dispatch [::events/set-dialog :close]))}
                            [:span "Cancel"]]
                           [:button
                            {:class "customer__save-button"
                             :type :submit
                             :disabled @submitting?}
                            (if @submitting?
                              [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                              [:span "Save"])]]]
                         [:p "Loading..."])]]])])
               [:div {:style {:display         "flex"
                              :justify-content "center"
                              :paddingLeft     "40px"
                              :paddingRight    "40px"
                              :align-items     "center"
                              :align-content   "center"
                              :margin-top       "20px"}}]]])
           [:div.component-holder
            (if (= tabs :history)
              [alerts-table (site/to-plain-id asset) permissions]
              (if (= tabs :notes)
                [asset-notes permissions]
                (if (= tabs :console)
                  [console-component gateway iqube scale]
                  (if (= tabs :accessories)
                    [accessories-component gateway current-status scale asset]))))]])
      [:div.center
       [components/loader]])))

(defn asset-profile []
  (let [{:keys [id basic-info components raw-data]}
        @(rf/subscribe [::sub/current-asset])]
    [:<>
     [assets.components/asset-profile-component id basic-info]
     [:div.components-head
      [:h2 "Components"]
      [:div.components-head__button
       [:button.btn.btn--md
        {:on-click
         (fn []
           (rf/dispatch [:modal {:show? true
                                 :title (str "Add Component")
                                 :child [forms/form-component
                                         (forms/add-asset-component (inc (count components)))]}]))}
        [:p.margin-right-xs "Add Component"]
        [:i.fas.fa-plus.color-success]]]]
     (for [[pos {:keys [component-type] :as component}] components]
       ^{:key pos}
       [:<>
        (case component-type
          :scale [assets.components/asset-scale-component pos component]
          :general [assets.components/asset-component-box pos component]
          nil)])]))

(defn one-iqube-header [gateway iqube customer site]
  (let [edit-dialog @(rf/subscribe [::sub/dialog])
        current-user @(rf/subscribe [::sub/current-user])]
    [:div.iqube-detail
     (when (= edit-dialog :close)
       (reset! submitting? false))
     (when (= edit-dialog :edit-iqube)
       [:div
        [:div.outside-modal
         {:on-click (fn []
                      (rf/dispatch [::events/set-dialog :close]))}]
        [:div
         {:style {:position        "fixed"
                  :top             "50%"
                  :left            "50%"
                  :border          "1px solid black"
                  :borderRadius    "5px"
                  :transform       "translate(-50%, -50%)"
                  :backgroundColor "white"
                  :zIndex          "100"
                  :padding         "20px"}}
         (let [state (r/atom nil)
               openapi      (rf/subscribe [::sub/data :openapi])
               current-user (rf/subscribe [::sub/current-user])
               dealerships  (rf/subscribe [::sub/data :dealerships])
               form-state   state]
           [:div {}
            [:h1 {:class "customer__sub-heading"} "Edit iQUBE"]
            (let [superuser? (contains? (:roles @current-user) "superuser")]
              [:<>
               [:div {:style {:display         "flex"
                              :flex-direction  "row"
                              :justify-content "space-between"}}
                [:div
                 {:style {:flex-grow 1}}
                 (if openapi
                   [openapi/form
                    {:openapi          @openapi
                     :schema-name      "iQube"
                     :form-data        @form-state
                     :remap-properties {"dealership" (when superuser?
                                                       #(openapi/create-enum % @dealerships))
                                        "name" (constantly {"title" "Name"
                                                            "type" "string"
                                                            "default" (:name iqube)})
                                        "ip" (constantly {"title" "IP Address"
                                                          "type" "string"
                                                          "default" (:ip iqube)})
                                        "timeout" (constantly {"title" "Timeout"
                                                               "type" "string"
                                                               "default" (:timeout iqube)})
                                        "boards" (if (:boards iqube)
                                                   (constantly {"title" "Number of Boards"
                                                                "type" "integer"
                                                                "default" (:boards iqube)
                                                                "minimum" 1
                                                                "maximum" 4})
                                                   (constantly {"title" "Number of Boards"
                                                                "type" "integer"
                                                                "minimum" 1
                                                                "maximum" 4}))
                                        "location" (constantly {"title" "Location"
                                                                "type" "string"
                                                                "default" (:location iqube)})
                                        "serial" (if (:serial iqube)
                                                   (constantly {"title" "Serial"
                                                                "type" "string"
                                                                "default" (:serial iqube)})
                                                   (constantly {"title" "Serial"
                                                                "type" "string"}))}
                     :on-submit        (fn [data]
                                         (rf/dispatch
                                          [::events/put-data
                                           (str "/api/iqubes/" (site/to-plain-id iqube))
                                           (cond-> data
                                             true (assoc :customer (site/to-plain-id customer))
                                             true (assoc :site (site/to-plain-id site))
                                             true (assoc :gateway (:id gateway)) 
                                             (nil? (:boards data)) (dissoc :boards)
                                             (nil? (:serial data)) (dissoc :serial)
                                             true (assoc :dealership (:dealership customer))) 
                                           [::events/modify-object-success "iQUBE Edited" :iqubes]])
                                         (reset! submitting? true)
                                         (rf/dispatch [:fetch/data [:iqube] (site/resource-path :iqubes (site/to-plain-id iqube))]))}
                    [:div.dropdown-input
                     [:label "Gateway"]
                     [:input.form-control {:type "text"
                                           :disabled true
                                           :value (:id gateway)}]]
                    [:div {:style {:display         "flex"
                                   :justify-content "center"
                                   :paddingLeft     "20px"
                                   :paddingRight    "20px"
                                   :margin-top      "15px"
                                   :align-items     "center"
                                   :align-content   "center"}}
                     [:button
                      {:class "customer__cancel-button"
                       :type "button"
                       :on-click (fn []
                                   (rf/dispatch [::events/set-dialog :close]))}
                      [:span "Cancel"]]
                     [:button
                      {:class "customer__save-button"
                       :type :submit
                       :disabled @submitting?}
                      (if @submitting?
                        [:span.spinner.spinner-dark {:style {:width "13.6px", :height "13.6px", :display "inline-flex"}}]
                        [:span "Save"])]]]
                   [:p "Loading..."])]]])])
         [:div {:style {:display         "flex"
                        :justify-content "center"
                        :paddingLeft     "40px"
                        :paddingRight    "40px"
                        :align-items     "center"
                        :align-content   "center"
                        :margin-top       "20px"}}]]])
       
     [:div.iqube-header
      [:img {:src "/img/icon-gateway.svg"}]
      [:span.gateway (:name gateway)]
      [:img {:src "/img/icon-arrow-right.svg"}]
      [:img {:src "/img/icon-accessories.svg"}]
      [:span.iqube (:name iqube)]
      (when (contains? (:permissions current-user) :modify-assets)
       [:div.edit-iqube-button {:on-click (fn []
                                            (rf/dispatch [:fetch/data [:iqube] (site/resource-path :iqubes (site/to-plain-id iqube))])
                                            (rf/dispatch [::events/set-dialog :edit-iqube]))}
        [:img {:src "/img/icon-edit.svg"}] "Edit"])]
     [:div.iqube-details
      [:span "Customer: "
       (if (some #(= % "superuser") (:roles current-user))
         [:a {:href (navigation/id-route
                     :customer
                     {:customer (site/to-plain-id customer)})}
          [:span.underline (:name customer)]]
         [:span (:name customer)])]
      [:span "Site: "
       (if (some #(= % "superuser") (:roles current-user))
         [:a {:href (navigation/id-route
                     :site
                     {:site (site/to-plain-id site)})}
          [:span.underline (:name site)]]
         [:span (:name site)])]
      [:span "IP Address: " (:ip iqube)]
      [:span "Location: " (:location iqube)]]]))

(defn one-iqube [k] 
  (let [{:keys [path-params]} @(rf/subscribe [::sub/current-route])
        customer @(rf/subscribe [::sub/data :customer])
        site @(rf/subscribe [::sub/data :site])
        status @(rf/subscribe [::sub/asset-status])
        gateway @(rf/subscribe [::sub/data :asset])
        iqube @(rf/subscribe [::sub/data :iqube])
        scales @(rf/subscribe [::sub/customer-scales (:customer iqube)])]
    (if (= (site/to-plain-id iqube) (:iqube-detail path-params))
      (do (when-not gateway
            (rf/dispatch [:fetch/data [:asset] (site/resource-path :assets (:gateway iqube))]))
          (when-not customer
            (rf/dispatch [:fetch/data [:customer] (site/resource-path :customers (:customer iqube))]))
          (when-not site
            (rf/dispatch [:fetch/data [:site] (site/resource-path :sites (:site iqube))]))
          [:div
           (one-iqube-header gateway iqube customer site)
           (let [iqube-scales (filterv #(= (:iqube %) (site/to-plain-id iqube)) scales)]
             (for [scale iqube-scales]
               ^{:key scale}
               (if (= (:number status) (:number scale))
                 (for [cell (:load-cells status)]
                   (rf/dispatch [::events/set-live-cells cell])))))
           [:div
            [components/subheader {:fixed? false
                                   :box-shadow? true}
             [:div
              [iqube-cells-subheader
               {:iqube iqube}]]]]])
      [:div
       [:div.center
        [components/loader]]])))